import React, { useLayoutEffect, useRef, useState } from "react";

function BulkTagSVG({ text, count }) {
	const displayText = text == null ? '' : String(text);
	const minTagWidth = 80;
	const horizontalPadding = 20;
	const tagPointWidth = 34;
	const [tagWidth, setTagWidth] = useState(minTagWidth);
	const textRef = useRef();

	useLayoutEffect(() => {
		const measuredWidth = textRef.current?.getBBox?.().width;
		const fallbackWidth = displayText.length * 8;
		const textWidth = Number.isFinite(measuredWidth) ? measuredWidth : fallbackWidth;
		setTagWidth(Math.max(textWidth + horizontalPadding + tagPointWidth, minTagWidth));
	}, [displayText, count]);

	const rectWidth = Math.max(tagWidth - tagPointWidth, 0);

	return (
		<svg
			className="pointer"
			height="26"
			viewBox={`0 0 ${tagWidth} 30`}
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path d="M15.0659 0L29.9999 14.934L14.934 30L3.53548 18.6015C1.58286 16.6489 1.58285 13.4831 3.53547 11.5304L15.0659 0Z" fill="#D9D9D9" />
			<rect width={rectWidth} height="30" transform="translate(15 0)" fill="#D9D9D9" />
			<text ref={textRef} x={rectWidth / 2 + 15} y="20" textAnchor="middle" fill="black">
				{displayText}
			</text>
		</svg>
	);
}

export default BulkTagSVG;
